import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { UsersManagement } from 'components/Settings/Components/UsersManagement/components/usersManagement';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const UsersManagementPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userManagement.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userManagement.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <UsersManagement />
            </MainContent>
        </PageContainer>
    );
};
